import { chatAktif, bukaChat } from "../chat/chatState";
import { terjemahPembeli } from "./galatPembeli";

// PR15 (KEPUTUSAN 21/10/2026 K3 v2 butir 2): batas pcs per pesanan. Server menolak dengan
// { detail, kode: "maks_pcs_pesanan", maks_pcs, nomor_whatsapp }; tampilan menampilkan teks server + tombol WhatsApp.
export const waTautan = (nomor, teks) => {
  const n = String(nomor || "").replace(/[^0-9]/g, "");
  return n ? `https://wa.me/${n}${teks ? `?text=${encodeURIComponent(teks)}` : ""}` : null;
};

export const teksWaBatas = (maks) =>
  `Halo, saya ingin bertanya tentang penawaran khusus untuk pembelian lebih dari ${Number(maks || 50000).toLocaleString("id-ID")} pcs.`;

// Info batas dari galat API, atau null bila galat lain
export function batasPcsDariGalat(err) {
  const d = err?.response?.data;
  return d && d.kode === "maks_pcs_pesanan" ? { pesan: terjemahPembeli(d.detail), nomor_whatsapp: d.nomor_whatsapp, maks_pcs: d.maks_pcs } : null;
}

// Batas pcs dari ringkasan keranjang/checkout yang sukses (summary.melebihi_maks_pcs, mis. sesudah admin menurunkan batas): teks server
// diterjemahkan seperti jawaban galat (review Codex tambahan 28/10)
export const batasDariRingkasan = (m) => (m ? { ...m, pesan: terjemahPembeli(m.pesan) } : null);

// Toast galat tambah/ubah keranjang: batas pcs → toast + tombol "Chat WhatsApp"; galat lain → teks cadangan
export function toastGalatKeranjang(toast, err, cadangan) {
  const b = batasPcsDariGalat(err);
  if (!b) { toast.error(cadangan); return; }
  const url = waTautan(b.nomor_whatsapp, teksWaBatas(b.maks_pcs));
  toast.error(b.pesan, {
    duration: 10000,
    ...(chatAktif() ? { action: { label: "Chat", onClick: () => bukaChat(null) } }
      : url ? { action: { label: "Chat WhatsApp", onClick: () => window.open(url, "_blank", "noopener,noreferrer") } } : {}),
  });
}
